import { render, staticRenderFns } from "./BaseFacilitySelect.vue?vue&type=template&id=96962b60&scoped=true"
import script from "./BaseFacilitySelect.vue?vue&type=script&lang=js"
export * from "./BaseFacilitySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96962b60",
  null
  
)

export default component.exports